export const ISO_COUNTRY_FR = "FR";
export const REPOSITORY_URL = "https://github.com/plogg-bucco/bucco-app";

export const CONSULTATION = 0;
export const PROTOCOL = 1;
export const KIT = 2;
export const ARTICLE = 3;

export const ALL_DENTISTS = "-1";

export const TEXTO_TAB = 0;
export const EMAILS_TAB = 1;
export const SECURE_FILE_TAB = 2;
export const NOTES_TAB = 3;
export const AVAILABLE_COUNTRIES = ["BE", "CA", "FR", "CH", "LU", "NL", "US", "GB", "ES", "AD", "MC", "IT"];

export const ALERT_HIDDEN = 0;
export const ALERT_SHOWN = 1;
export const ALERT_BLOCKED = 2;
export const SINGLE_BLOCK_HEIGHT = 100;
export const SELECT_MAX_HEIGHT = 200;

export const GOOGLE_PROVIDER = "google";
export const OUTLOOK_PROVIDER = "MICROSOFT";
export const EMAIL_PROVIDERS = {
	[GOOGLE_PROVIDER]: "google",
	[OUTLOOK_PROVIDER]: "outlook"
};

export const CONSULTATION_WHITELIST = [
	"19sXkyV5X3H5blTtfRTj",
	"waR8AzOXCCIAprMQJnU1",
	"dTquVrHDuuHO12mV1pQ0",
	"t1nn2HfT3442uOT30KK1",
	"gtMY94MBsuj02oqiTGVO",
	"303obtTkZOLg48TtT2Rp",
	"znjthHJP7Gh4MRqhTfbp"
];

export const DEFAULT_DATE = "1970-01-01";

export const IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png"];

export const DIALOG_MAX_WIDTH = "600";
export const GROUP_DIALOG_WIDTH = "75%";

export const MAX_SIZE_ATTACHMENT_SIZE_IN_BYTE = 500000000;
export const MAX_EMAIL_ATTACHMENT_TOTAL_SIZE_IN_BYTE = 18 * 1024 * 1024; // 18 MB
// MMS: Twilio caps the whole message at 5 MB (5 242 880 bytes) and transcodes images, but never resizes PDFs (carrier limit ~600 KB)
export const MAX_IMAGE_SIZE = 5200000;
export const MAX_PDF_SIZE = 600000;
export const MAX_NOTE_LENGTH = 10000;
export const MAX_UPLOAD_SIZE = 25000000;

// Keep in sync with backend src/faxes/types/fax-file.constants.ts (20 MB).
export const MAX_FAX_UPLOAD_SIZE = 20 * 1024 * 1024;

export const SMS_SEGMENT_LENGTH = 160;
export const USER_SIGNATURE_LENGTH = 200;

export const DEFAULT_WEEK_SCHEDULE = [
	{
		day: 0,
		enabled: false,
		end: "17:00",
		start: "9:00"
	},
	{
		day: 1,
		enabled: true,
		end: "17:00",
		start: "9:00"
	},
	{
		day: 2,
		enabled: true,
		end: "17:00",
		start: "9:00"
	},
	{
		day: 3,
		enabled: true,
		end: "17:00",
		start: "9:00"
	},
	{
		day: 4,
		enabled: true,
		end: "17:00",
		start: "9:00"
	},
	{
		day: 5,
		enabled: true,
		end: "17:00",
		start: "9:00"
	},
	{
		day: 6,
		enabled: false,
		end: "17:00",
		start: "9:00"
	}
];

export const DEFAULT_WORKDAY_SCHEDULE = [
	{
		day: 0,
		enabled: false,
	 	start: "09:00",
	 	end: "17:00",
		breaks: []
	},
	{
		day: 1,
		enabled: true,
	 	start: "09:00",
	 	end: "17:00",
		breaks: []
	},
	{
		day: 2,
		enabled: true,
		start: "09:00",
		end: "17:00",
		breaks: []
	},
	{
		day: 3,
		enabled: true,
		start: "09:00",
		end: "17:00",
		breaks: []
	},
	{
		day: 4,
		enabled: true,
		start: "09:00",
		end: "17:00",
		breaks: []
	},
	{
		day: 5,
		enabled: true,
		start: "09:00",
		end: "17:00",
		breaks: []
	},
	{
		day: 6,
		enabled: false,
		start: "09:00",
		end: "17:00",
		breaks: []
	}
];

export const WEEK_DAYS = 7;
export const DAY_HOURS = 24;

export const EMAIL_STATUS = {
	SENDING: "sending",
	SENT: "sent"
};

export const MAX_ACTIVE_ALERTS = 3;

export const PHONE_CALL_STATUS = {
	NO_ANSWER: "no-answer",
	BUSY : "busy",
	CANCELED: "canceled",
	COMPLETED: "completed",
	PENDING: "pending"
};

export const CACHED_CALL_STATUS = {
	INITIATED:1,
	RINGING:2,
	IN_PROGRESS:3,
	QUEUED:4,
	PARKED:5,
	HOLD:6,
	COMPLETED:7,
	ENDED:8
};

export const NOTIF_CALL_DURATION = 90;
export const MESSAGE_MAX_CHARACTER_COUNT = 600;
export const MESSAGE_PREVIEW_MAX_CHARACTER_COUNT = 120;
export const LOCALE_FR = "fr-FR";
export const MAX_CONTACT_PAGES = 10;
export const MIN_SEARCH_LENGTH = 3;

export const USER_NAME_MAX_LENGTH = 50;
export const CONTACT_NAME_MAX_LENGTH = 50;
export const CONTACT_EMAIL_MAX_LENGTH = 120;

export const AUTHENTICATION_WINDOW_NAME = "fresk_authentication_window";

export const PROVIDER_NAME_MAP = {
	google: "Gmail",
	outlook: "Outlook"
};

export const DEFAULT_LOCALE = "fr-CA";

export const LANGUAGE = {
	"fr-CA": "Français (Canada)",
	"en-CA": "English (Canada)"
};

export const SUPPORT_LANGUAGES = {
	...LANGUAGE,
	"ar-SA": "Arabic",
	"zh-CN": "Chinese (Mandarin)",
	"ht-HT": "Haitian Creole",
	"hi-IN": "Hindi",
	"it-IT": "Italian",
	"pa-IN": "Punjabi",
	"pl-PL": "Polish",
	"pt-PT": "Portuguese",
	"ru-RU": "Russian",
	"es-ES": "Spanish",
	"vi-VN": "Vietnamese"
};

export const ROLES = {
	ADMIN: "admin",
	SUPER_ADMIN: "super-admin",
	USER: "user",
	DEVOPS: "devops",
	MARKETING: "marketing"
};

export const SIGNATURE_OPTION = {
	NO_SIGNATURE: "no-signature",
	CLINIC: "clinic",
	USER: "user",
	PERSONALIZED_SIGNATURE: "personalized-signature"
};

export const MessageType = {
	MEDIA: "media",
	TEXT: "text", // Twilio type
	SMS: "sms",
	AUTO_RESPONSE: "auto",
	EMAIL: "email",
	CALL: "call",
	FILE_REQUEST: "request",
	CALLBACK_REQUEST: "callback-request",
	CUSTOMER_REQUEST: "customer-request",
	MESSAGE_MERGING: "message-merging"
};

export const MessageAuthor = {
	AutoResponse: "auto",
	Contact: "contact",
	UserGroup: "group"
};

export const MediaContentType = {
	AUDIO: "audio",
	IMAGE: "image",
	JPEG: "jpeg",
	PDF: "pdf",
	PNG: "png"
};

export const MAX_EMAIL_LENGTH = 2500;
export const MAX_EMAIL_SUBJECT_LENGTH = 255;
export const ANONYMOUS_CALLERS = new Set(["+266696687", "Anonymous"]);
export const SUPPORT_PHONE = "+15799771251";
export const SUPPORT_NAME = "Support Fresk";
export const SUPPORT_BUSINESS = "Fresk";
export const SUPPORT_EMAIL = "support@fresk.app";

export const EMERGENCY_ID = "+1911";
export const TEST_EMERGENCY_ID = "+1933";
export const EMERGENCY_NUMBERS = new Set([EMERGENCY_ID, TEST_EMERGENCY_ID]);

export const IS_ANONYMOUS = (phoneNumber) => {
	if (!phoneNumber) return false;

	if (!phoneNumber.startsWith("+")) {
		phoneNumber = `+${phoneNumber}`;
	}

	return ANONYMOUS_CALLERS.has(phoneNumber);
};

export const IS_EMERGENCY = (phoneNumber) => {
	if (!phoneNumber) return false;

	if (!phoneNumber.startsWith("+")) {
		phoneNumber = `+${phoneNumber}`;
	}

	return EMERGENCY_NUMBERS.has(phoneNumber);
};

export const IS_SUPPORT = (phoneNumber) => {
	return phoneNumber === SUPPORT_PHONE;
};

// Softphone "To" of a direct call to a transfer extension: ext.<transferExtensionId>
export const EXTENSION_CALL_PREFIX = "ext.";

export const isExtensionCall = (to) => {
	return typeof to === "string" && to.startsWith(EXTENSION_CALL_PREFIX);
};

export const EMERGENCY_OR_ANONYMOUS_LABEL = (phoneNumber) => {
	if (!phoneNumber) return undefined;

	if (!phoneNumber.startsWith("+")) {
		phoneNumber = `+${phoneNumber}`;
	}

	if (IS_EMERGENCY(phoneNumber)) {
		return phoneNumber === EMERGENCY_ID ? "emergency-call" : "emergency-call-test";
	}

	if (IS_ANONYMOUS(phoneNumber)) {
		return "anonymous";
	}
};

export const HelpCenterLink = {
	FR_FR: "https://fresk.app/aide/",
	FR_CA: "https://fresk.app/fr/help-center/",
	EN_CA: "https://fresk.app/en/help-center/"
};

export const QUEUE_WAIT_TIME = {
	RED: 240, // 4 minutes
	YELLOW: 120 // 2 minutes
};

export const VOICEMAIL_STATE = {
	OPEN: "OPEN",
	CLOSE: "CLOSE",
	BREAK: "BREAK",
	VACATION: "VACATION"
};

export const TUTORIAL_TYPE = {
	YOUTUBE: "YOUTUBE",
	LOOM: "LOOM",
	CLOSE: "CLOSE",
	BREAK: "BREAK",
	VACATION: "VACATION"
};

export const LinkedTypes = [
	"boyfriend",
	"brother",
	"brother-in-law",
	"daughter",
	"daughter-in-law",
	"father",
	"father-in-law",
	"girlfriend",
	"husband",
	"mother",
	"mother-in-law",
	"none",
	"sister",
	"sister-in-law",
	"son",
	"son-in-law",
	"wife"
];

export const SALUTATION_VALUES = ["mr", "ms", "miss", "dr"];

export const GENDER_VALUES = ["male", "female", "other"];

export const STEP_KEYS = {
	TROUBLESHOOTING_DEVOPS: "troubleshooting-devops",
	TROUBLESHOOTING_USER: "troubleshooting-user"
};

export const CATEGORY_ICONS = {
	application: "mdi-laptop",
	headset: "mdi-headset",
	message: "mdi-message",
	notification: "mdi-bell-ring",
	phone: "mdi-phone",
	ringtone: "mdi-phone-ring",
	voicemail: "mdi-voicemail"
};

export const YOUTUBE_EMBED_URL = "https://www.youtube.com/embed/";

export const VOICEMAIL_TYPE = {
	FILE: "FILE",
	TTS: "TTS",
	RECORDING: "RECORDING"
};

export const COLOR_SWATCHES = [
	["#FF5252", "#FF4081", "#E040FB", "#7C4DFF", "#536DFE", "#448AFF", "#40C4FF", "#18FFFF"],
	["#64FFDA", "#69F0AE", "#B2FF59", "#EEFF41", "#FFFF00", "#FFD740", "#FFAB40", "#FF6E40"]
];

export const SELECT_TYPE = {
	SELECT_ONE: "select-one",
	SELECT_ALL: "select-all",
	SELECT_VISIBLE: "select-visible",
	UNSELECT_ONE: "unselect-one",
	UNSELECT_ALL: "unselect-all"
};

export const EMAIL_VIEW_MODE = {
	LIST: "list",
	READ: "read",
	COMPOSE: "compose"
};

export const GMAIL_FOLDERS = {
	INBOX: "INBOX",
	SENT: "SENT",
	DRAFTS: "DRAFTS",
	TRASH: "TRASH",
	SPAM: "SPAM",
	STARRED: "STARRED",
	IMPORTANT: "IMPORTANT",
	SNOOZED: "SNOOZED",
	ALL_MAIL: "ALL_MAIL"
};

export const OUTLOOK_FOLDERS = {
	INBOX: "Inbox",
	SENT: "SentItems",
	TRASH: "DeletedItems",
	FLAGGED: "flagged",
	SPAM: "JunkEmail"
};

export const TRANSCRIPTION_STATUS_CONFIG = {
	COMPLETED: {
		icon: "mdi-lightbulb-on",
		tooltip: "transcription-view",
		buttonText: "transcription-view"
	},
	FAILED: {
		icon: "mdi-alert-circle",
		tooltip: "transcription-retry",
		buttonText: "transcription-retry"
	},
	PROCESSING: {
		icon: "mdi-progress-clock",
		tooltip: "transcribing",
		buttonText: "thinking"
	},
	PENDING: {
		icon: "mdi-progress-clock",
		tooltip: "transcribing",
		buttonText: "thinking"
	},
	DEFAULT: {
		icon: "mdi-text-box",
		tooltip: "transcribe",
		buttonText: "transcribe"
	},
	// For multi-recording, default uses a different icon
	MULTI_DEFAULT: {
		icon: "mdi-lightbulb-on",
		tooltip: "transcribe",
		buttonText: "transcribe"
	}
};

export const NON_RETRYABLE_TRANSCRIPTION_ERRORS = [
	"RECORDING_DELETED",
	"CONVERSATION_NOT_FOUND",
	"FILE_TOO_LARGE",
	"UNSUPPORTED_FORMAT",
	"AUDIO_TOO_LONG",
	"SILENCE_ONLY"
];
